import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="py-16 md:py-20 relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Soft%20warm%20abstract%20gradient%20with%20gentle%20flowing%20shapes%20in%20terracotta%20coral%20and%20warm%20amber%20tones%2C%20peaceful%20harmonious%20atmosphere%2C%20minimalist%20abstract%20art%2C%20warm%20gentle%20light%2C%20no%20text%2C%20clean%20modern%20design&width=1800&height=600&seq=cta-bg-community&orientation=landscape"
          alt="加入社区背景"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-primary-600/80 to-accent-600/60"></div>
      </div>

      <div className="relative z-10 max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-background-50 mb-4">
          准备好加入我们的社区了吗？
        </h2>
        <p className="text-background-50/90 text-base mb-8 max-w-xl mx-auto">
          五万多名社群成员正在等待你的加入。无论你是想交友、获取资讯还是参加活动，这里都是你的归属。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/jiaoyou"
            className="px-8 py-3.5 bg-background-50 text-primary-600 rounded-full text-base font-semibold hover:bg-background-100 transition-all whitespace-nowrap cursor-pointer"
          >
            免费加入
          </Link>
          <Link
            to="/about"
            className="px-8 py-3.5 border-2 border-background-50/50 text-background-50 rounded-full text-base font-medium hover:bg-background-50/10 transition-all whitespace-nowrap cursor-pointer"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}